import {
  CheckBadgeIcon,
  DocumentTextIcon,
  IdentificationIcon,
} from '@heroicons/react/24/outline'
import { PrinterIcon, UserIcon } from 'lucide-react'

export const stats = (statistics) => {
  const statistic = statistics?.data ?? {}
  return [
    {
      label: 'Total Residents',
      value: statistic.total_residents,
      icon: UserIcon,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600',
      description: 'Registered residents',
    },
    {
      label: 'With Digital ID',
      value: statistic.total_issued_digital_id,
      icon: IdentificationIcon,
      bgColor: 'bg-green-100',
      textColor: 'text-green-600',
      description: 'Active digital IDs',
    },
    /*     {
      label: 'QR Codes',
      value: qrGenerated,
      icon: QrCodeIcon,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-600',
      description: 'QR codes available'
    }, */
    {
      label: 'IDs Printed',
      value: statistic.total_ids_printed,
      icon: PrinterIcon,
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-600',
      description: 'Physical IDs issued',
    },
    {
      label: 'Registered Voters',
      value: statistic.total_registered_voter,
      icon: CheckBadgeIcon,
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-600',
      description: 'Eligible voters',
    },
    {
      label: 'This Month',
      value: statistic.total_registered_this_month,
      icon: DocumentTextIcon,
      bgColor: 'bg-teal-100',
      textColor: 'text-teal-600',
      description: 'New registrations',
    },
  ]
}
